import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=6450d3b4&scoped=true&"
import script from "./MonthlyReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450d3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6450d3b4')) {
      api.createRecord('6450d3b4', component.options)
    } else {
      api.reload('6450d3b4', component.options)
    }
    module.hot.accept("./MonthlyReport.vue?vue&type=template&id=6450d3b4&scoped=true&", function () {
      api.rerender('6450d3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/Statistics/MonthlyReport.vue"
export default component.exports